<template>
  <div>
    <a-form class="mb-3" :form="form" @submit="handleSubmit">
      <p class="neo_form_sub_heading">Upload Documents</p>
      <div class="row pb-3">
        <!-- Photo -->
        <div class="col-md-4">
          <div>
            <img v-if="applicantData.photo" :src="applicantData.photo" alt="student photo" class="img-fluid mb-2" width="200">
          </div>
          <a-form-item
            label="Student Photo"
          >
            <a-upload
              v-decorator="['photo',{rules: [{ required: applicantData.photo ? false : true, message: 'Please select a photo!'}]}]"
              :multiple="false"
              :remove="handleRemove"
              :beforeUpload="beforeUpload"
              accept=".jpg,.jpeg,.png"
            >
              <a-button v-if="form.getFieldValue('photo') ? form.getFieldValue('photo').fileList.length !== 0 ? false : true : true">
                <a-icon type="upload" /> {{this.applicantData.photo ? 'Replace Photo' : 'Select Photo'}}
              </a-button>
            </a-upload>
          </a-form-item>
          <p class="font-italic text-warning">Should be JPG/PNG and less than 2MB </p>
        </div>

        <!-- Student Signature -->
        <div class="col-md-4">
          <div>
            <img v-if="applicantData.student_signature" :src="applicantData.student_signature" alt="student signature" class="img-fluid mb-2" width="200">
          </div>
          <a-form-item
            label="Student's Signature"
          >
            <a-upload
              v-decorator="['student_signature',{rules: [{ required: applicantData.student_signature ? false : true, message: 'Please select a photo!'}]}]"
              :multiple="false"
              :remove="handleRemove"
              :beforeUpload="beforeUpload"
              accept=".jpg,.jpeg,.png"
            >
              <a-button v-if="form.getFieldValue('student_signature') ? form.getFieldValue('student_signature').fileList.length !== 0 ? false : true : true">
                <a-icon type="upload" /> {{this.applicantData.student_signature ? 'Replace Signature' : 'Select Signature'}}
              </a-button>
            </a-upload>
          </a-form-item>
          <p class="font-italic text-warning">Should be JPG/PNG and less than 2MB </p>
        </div>

        <!-- Mark sheet -->
        <div class="col-md-4">
          <a-form-item
            label="Marksheet (Optional)"
          >
            <div v-if="this.applicantData.document">
              <a :href="this.applicantData.document" class="btn btn-sm btn-dark" target="_blank">View Document</a>
            </div>
            <a-upload
              v-decorator="['document',{rules: [{ required: applicantData.document ? false : true, message: 'Please add marksheet!'},]}]"
              :multiple="false"
              :remove="handleRemove"
              :beforeUpload="beforeUploadDoc"
              accept=".jpg,.jpeg,.png,.pdf"
            >
              <a-button v-if="form.getFieldValue('document') ? form.getFieldValue('document').fileList.length !== 0 ? false : true : true">
                <a-icon type="upload" /> {{this.applicantData.document ? 'Replace File' : 'Select File'}}
              </a-button>
            </a-upload>
          </a-form-item>
          <p class="font-italic text-warning">Should be JPG/PNG/PDF and less than 3MB </p>
        </div>

        <!-- Admit card -->
        <div class="col-md-4">
          <a-form-item
            label="Admit card/Student ID Card"
          >
            <div v-if="this.applicantData.admit_card">
              <a :href="this.applicantData.admit_card" class="btn btn-sm btn-dark" target="_blank">View Document</a>
            </div>
            <a-upload
              v-decorator="['admit_card', {rules: [{ required: applicantData.admit_card ? false : true, message: 'Please add admit card!'},]}]"
              :multiple="false"
              :remove="handleRemove"
              :beforeUpload="beforeUploadDoc"
              accept=".jpg,.jpeg,.png,.pdf"
            >
              <a-button v-if="form.getFieldValue('admit_card') ? form.getFieldValue('admit_card').fileList.length !== 0 ? false : true : true">
                <a-icon type="upload" /> {{this.applicantData.admit_card ? 'Replace File' : 'Select File'}}
              </a-button>
            </a-upload>
          </a-form-item>
          <p class="font-italic text-warning">Should be JPG/PNG/PDF and less than 3MB </p>
        </div>

        <div class="col-md-4">
          <a-form-item label="Are you a sports person?">
            <a-select
              v-decorator="[`sports_person`, {rules: [{ required: true, message: 'Please input an answer!'},], initialValue: 0}]"
            >
              <a-select-option :value="0">
                No
              </a-select-option>
              <a-select-option :value="1">
                Yes
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <!-- Sport cert -->
        <div class="col-md-4" v-if="form.getFieldValue('sports_person')">
          <a-form-item
            label="Sport cert"
          >
            <div v-if="this.applicantData.sport_cert">
              <a :href="this.applicantData.sport_cert" class="btn btn-sm btn-dark" target="_blank">View Document</a>
            </div>
            <a-upload
              v-decorator="['sport_cert', {rules: [{ required: applicantData.sport_cert ? false : form.getFieldValue('sports_person') ? true : false, message: 'Please add a certificate!'},]}]"
              :multiple="false"
              :remove="handleRemove"
              :beforeUpload="beforeUploadDoc"
              accept=".jpg,.jpeg,.png,.pdf"
            >
              <a-button v-if="form.getFieldValue('sport_cert') ? form.getFieldValue('sport_cert').fileList.length !== 0 ? false : true : true">
                <a-icon type="upload" /> {{this.applicantData.sport_cert ? 'Replace File' : 'Select File'}}
              </a-button>
            </a-upload>
          </a-form-item>
          <p class="font-italic text-warning">Should be JPG/PNG/PDF and less than 3MB </p>
        </div>

        <!-- Parent / Guardian Signature -->
        <div class="col-md-4">
          <div>
            <img v-if="applicantData.parent_signature" :src="applicantData.parent_signature" alt="parent/guardian signature" class="img-fluid mb-2" width="200">
          </div>
          <a-form-item
            label="Parent / Guardian Signature"
          >
            <a-upload
              v-decorator="['parent_signature',{rules: [{ required: applicantData.parent_signature ? false : true, message: 'Please select a photo!'}]}]"
              :multiple="false"
              :remove="handleRemove"
              :beforeUpload="beforeUpload"
              accept=".jpg,.jpeg,.png"
            >
              <a-button v-if="form.getFieldValue('parent_signature') ? form.getFieldValue('parent_signature').fileList.length !== 0 ? false : true : true">
                <a-icon type="upload" /> {{this.applicantData.parent_signature ? 'Replace Signature' : 'Select Signature'}}
              </a-button>
            </a-upload>
          </a-form-item>
          <p class="font-italic text-warning">Should be JPG/PNG and less than 2MB </p>
        </div>
      </div>

      <a-divider />

      <div class="row mt-3">
        <div class="col-md-6">
          <a-button
            type="primary"
            size="large"
            class="text-center btn btn-dark font-weight-bold font-size-18 mt-2"
            v-on:click.prevent="handlePrevious"
          >Previous</a-button>
        </div>
        <div class="col-md-6 text-md-right">
          <a-button
            type="primary"
            htmlType="submit"
            size="large"
            class="text-center btn btn-primary font-weight-bold font-size-18 mt-2"
          >Save & Next</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    return value
  },
}

export default {
  name: 'FormStepFour',
  props: ['applicantData', 'applicationFormData'],

  mounted() {
    this.$nextTick(() => {
      this.form.setFieldsValue({
        sports_person: this.applicantData['sports_person'],
      })
    })
  },

  data() {
    return {
      form: this.$form.createForm(this),
      fileList: [],
    }
  },
  computed: {
    ...mapState(['applicant']),
  },
  methods: {
    handlePrevious() {
      this.$emit('previous', 3)
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file]
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isPNG)) {
        this.$message.error('You can upload only JPG or PNG file!')
        this.handleRemove(file)
      }
      const isLt2M = file.size / 1024 / 1024 < 2.5
      if (!isLt2M) {
        this.$message.error('Image must be smaller than 2MB!')
        this.handleRemove(file)
      }
      return false
    },
    beforeUploadDoc(file) {
      this.fileList = [...this.fileList, file]
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isPDF = file.type === 'application/pdf'
      if (!(isJPG || isPNG || isPDF)) {
        this.$message.error('You can upload only JPG, PNG or PDF file!')
        this.handleRemove(file)
      }
      const isLt2M = file.size / 1024 / 1024 < 3
      if (!isLt2M) {
        this.$message.error('Image must smaller than 3MB!')
        this.handleRemove(file)
      }
      return false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to save your academic data.`,
            onOk: () => {
              // Get student Photo
              let photoFile = null
              if (values.photo) {
                if (values.photo.fileList.length !== 0) {
                  photoFile = values.photo.file
                  values.photo = undefined
                }
              }
              delete values.photo

              // Get student Signature
              let signatureFile = null
              if (values.student_signature) {
                if (values.student_signature.fileList.length !== 0) {
                  signatureFile = values.student_signature.file
                  values.student_signature = undefined
                }
              }
              delete values.student_signature

              // Get Document
              let docFile = null
              if (values.document) {
                if (values.document.fileList.length !== 0) {
                  docFile = values.document.file
                  values.document = undefined
                }
              }
              delete values.document

              // Get Admitcard
              let admitCardFile = null
              if (values.admit_card) {
                if (values.admit_card.fileList.length !== 0) {
                  admitCardFile = values.admit_card.file
                  values.admit_card = undefined
                }
              }
              delete values.admit_card

              // Get Sport Cert
              let sportCertFile = null
              if (values.sport_cert) {
                if (values.sport_cert.fileList.length !== 0) {
                  sportCertFile = values.sport_cert.file
                  values.sport_cert = undefined
                }
              }
              delete values.sport_cert

              // Get parent Signature
              let parentSignatureFile = null
              if (values.parent_signature) {
                if (values.parent_signature.fileList.length !== 0) {
                  parentSignatureFile = values.parent_signature.file
                  values.parent_signature = undefined
                }
              }
              delete values.parent_signature

              let formData = window.jsonToFormData(values, options)

              if (photoFile) {
                formData.append('photo', photoFile)
              }
              if (signatureFile) {
                formData.append('student_signature', signatureFile)
              }
              if (docFile) {
                formData.append('document', docFile)
              }
              if (admitCardFile) {
                formData.append('admit_card', admitCardFile)
              }
              if (values.sports_person && sportCertFile) {
                formData.append('sport_cert', sportCertFile)
              }
              if (parentSignatureFile) {
                formData.append('parent_signature', parentSignatureFile)
              }

              formData.append('_method', 'PATCH')

              this.$http
                .post(`/api/application-form/upload/${this.applicantData.id}`, formData, {
                  params: {
                    token: this.applicant.app_form_token,
                  },
                })
                .then(({ data }) => {
                  if (data.type === 'error') {
                    this.$applicantAuth.logout()
                  } else {
                    this.$emit('saved')
                    this.loading = false
                    this.fileList = []
                    this.form.resetFields()

                    this.$notification['success']({
                      message: 'Successfully uploaded!',
                      description: `Your files have been uploaded successfully!`,
                    })
                  }
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
  },
}
</script>
